<template>
  <div class="content-wrapper" :class="{ 'loading-opacity': preloader }">
    <app-overlay-loader v-if="preloader" />
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Ajuste"
          directory="Loc. Crítica o U. Técnica"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            Regresar
          </button>
        </div>
      </div>
    </div>

    <div v-if="['OINSP'].includes(inputs?.accreditation_activity?.code)">
        <setting-oinsp-location-critical-index
            title="LOCACIONES CRITICAS DEL ORGANISMO"
            :subtitle="$store.getters.getTag('3.2.S')"
            :footer="$store.getters.getTag('3.2.F')"
        />
    </div>

    <div v-if="['OENY'].includes(inputs?.accreditation_activity?.code)">
        <setting-oeny-location-physical-index
            title="REGISTRO DE UNIDADES TÉCNICAS"
            :subtitle="$store.getters.getTag('4.2.S')"
            :footer="$store.getters.getTag('4.2.F')"
            establishmentType="TU"
            :activity="codeactivity"
        />
    </div>

    <div v-if="['OEYC'].includes(inputs?.accreditation_activity?.code)">
        <setting-oeyc-location-physical-index
            title="UNIDADES TÉCNICAS (Cuando aplique)"
            :subtitle="$store.getters.getTag('4.2.S')"
            :footer="$store.getters.getTag('4.2.F')"
            establishmentType="TU"
            :activity="codeactivity"
        />
    </div>

    <div v-if="['OCLN'].includes(inputs?.accreditation_activity?.code)">
        <setting-ocln-location-physical-index
            title="SUCURSALES (Cuando aplique)"
            :subtitle="$store.getters.getTag('4.2.S')"
            :footer="$store.getters.getTag('4.2.F')"
            establishmentType="TU"
            :activity="codeactivity"
         />
    </div> 

    <div v-if="['OICC'].includes(inputs?.accreditation_activity?.code)">
        <setting-oicc-location-physical-index
            title="UNIDADES TÉCNICAS (Cuando aplique)"
            :subtitle="$store.getters.getTag('4.2.S')"
            :footer="$store.getters.getTag('4.2.F')"
            establishmentType="TU"
            :activity="codeactivity"
        />
    </div>

    <div v-if="['OCSG'].includes(inputs?.accreditation_activity?.code)">
        <setting-ocsg-location-critical-index
            title="LOCALIZACIONES CRÍTICAS DEL ORGANISMO"
            :subtitle="$store.getters.getTag('3.2.S')"
            :footer="$store.getters.getTag('3.2.F')"
            :activity="codeactivity"
        />
    </div>

    <div v-if="['OCPE'].includes(inputs?.accreditation_activity?.code)">
        <setting-ocpe-location-physical-index
            title="OTRAS UBICACIONES FÍSICAS DEL ORGANISMO DE CERTIFICACIÓN SOLICITANTE"
            :subtitle="$store.getters.getTag('3.2.S')"
            :footer="$store.getters.getTag('3.2.F')"
            :activity="codeactivity"
        />
    </div>

    <div v-if="['OCPR'].includes(inputs?.accreditation_activity?.code)">
        <setting-ocpr-location-critical-index
            title="LOCALIZACIONES CRÍTICAS DEL ORGANISMO SOLICITANTE:"
            :subtitle="$store.getters.getTag('3.2.S')"
            :footer="$store.getters.getTag('3.2.F')"
            :activity="codeactivity"
        />
    </div>

    <div v-if="['CSIA'].includes(inputs?.accreditation_activity?.code)">
        <setting-csia-location-critical-index
            title="LOCALIZACIONES CRÍTICAS DEL ORGANISMO"
            :subtitle="$store.getters.getTag('3.2.S')"
            :footer="$store.getters.getTag('3.2.F')"
            :activity="codeactivity"
        />
    </div>

    <div v-if="['CSA'].includes(inputs?.accreditation_activity?.code)">
        <setting-csa-location-critical-index
            title="LOCALIZACIONES CRÍTICAS DEL ORGANISMO"
            :subtitle="$store.getters.getTag('3.2.S')"
            :footer="$store.getters.getTag('3.2.F')"
            :activity="codeactivity"
        />
    </div>

    <div v-if="['CSGAS'].includes(inputs?.accreditation_activity?.code)">
        <setting-csgas-location-critical-index
            title="LOCALIZACIONES CRÍTICAS DEL ORGANISMO"
            :subtitle="$store.getters.getTag('3.2.S')"
            :footer="$store.getters.getTag('3.2.F')"
            :activity="codeactivity"
        />
    </div>

    <div v-if="['CSDM'].includes(inputs?.accreditation_activity?.code)">
        <setting-csdm-location-critical-index
            title="LOCALIZACIONES CRÍTICAS DEL ORGANISMO"
            :subtitle="$store.getters.getTag('3.2.S')"
            :footer="$store.getters.getTag('3.2.F')"
            :activity="codeactivity"
        />
    </div>

    <div v-if="['CSST'].includes(inputs?.accreditation_activity?.code)">
        <setting-csst-location-critical-index
            title="LOCALIZACIONES CRÍTICAS DEL ORGANISMO"
            :subtitle="$store.getters.getTag('3.2.S')"
            :footer="$store.getters.getTag('3.2.F')"
            :activity="codeactivity"
        />
    </div>

    <div v-if="['CSEN'].includes(inputs?.accreditation_activity?.code)">
        <setting-csen-location-critical-index
            title="LOCALIZACIONES CRÍTICAS DEL ORGANISMO"
            :subtitle="$store.getters.getTag('3.2.S')"
            :footer="$store.getters.getTag('3.2.F')"
            :activity="codeactivity"
        />
    </div>  

    <div v-if="['OVV'].includes(inputs?.accreditation_activity?.code)">
         <setting-ovv-location-critical-index
            title="LOCALIZACIONES CRÍTICAS DEL ORGANISMO"
            :subtitle="$store.getters.getTag('3.2.S')"
            :footer="$store.getters.getTag('3.2.F')"
            :activity="codeactivity"
        />
    </div>

  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { axiosGet } from "@/app/helpers/AxiosHelper";
export default {
    mixins: [FormMixin],
    props: {
    accAppId: String,
    },
    data() {
        return {
            preloader: false,
            codeactivity: "",
            inputs: {},
        };
    },
    created() {
        this.data();
        this.$store.state.accreditation.id = this.accAppId;
    },
    methods: {
        returnPage() {
            window.location.href = `/accreditationtechnical/setting-information/location`;
        },
        data() {
            this.preloader = true;
            this.$store.dispatch("getPoliticalDivision");
            axiosGet(
                `/accreditationtechnical/setting-information/location/show/${this.accAppId}`
            )
            .then((response) => {
            if (response.status == 200) {
                this.inputs = response.data ? response.data : {};
                this.codeactivity = response.data.accreditation_activity.code;
            }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                this.preloader = false;
            });
        }
    }
}
</script>

<style>

</style>